module.exports = __webpack_public_path__ + "static/second-cd4387d838d2f0e905648d93e386465d.png";